<div
  [ngClass]="{
    'vendor-profile-container': true,
    'with-profile-picture': true,
  }">
  <iu-avatar-ui
    class="picture"
    iuLoading
    [avatarInfos]="avatarInfos()"
    [dataToWatch]="data()?.profilePicture"
    (onTimeout)="changeLoadingState($event)" />
  <div class="name" iuLoading [dataToWatch]="data()?.fullName">
    @if (data()?.fullName) {
      <h1>{{ data().fullName }}</h1>
      <i aria-hidden="true" class="edit-button-icon icon-edit-pencil" role="button" (click)="editBtnClick($event)"></i>
    }
  </div>
  <div class="type" iuLoading [dataToWatch]="data()?.type">
    @if (data()?.type) {
      <h2>{{ data()?.type }}</h2>
    }

    @if (data()?.isForbidden) {
      <i aria-hidden="true" class="icon-blocked"></i>
    }
  </div>
  <div class="rating" iuLoading [dataToWatch]="data()?.rating">
    <iu-input-stars-ui [data]="data()?.rating" />
  </div>
  <div class="top" iuLoading [dataToWatch]="data()?.top">
    @if (data()?.top > 0) {
      <span class="top-label">{{ 'vendorProfile.topLabel' | translate }}</span>
      <span class="top-value">{{ data()?.top }}</span>
    }
  </div>
</div>
